/* eslint-disable @typescript-eslint/ban-types */
import { ObjKey } from '../../../model/Object'
import { BaseCallbackOptions, Context } from '../../../model/Decorator'

export function TryEndingAsync<T extends Context>(callback: ({ context, propertyKey }: BaseCallbackOptions<T>) => any) {
  return function <TFunction extends Function>(
    _target: object | TFunction,
    propertyKey: ObjKey,
    descriptor: any = {},
  ) {
    const method = descriptor?.value

    descriptor.value = async function(...args: unknown[]) {
      const result = await method.apply(this, args)

      callback({ context: this, propertyKey })

      return result
    }
  }
}
